var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8356 0.233569C15.5997 -0.0495853 15.1783 -0.0848844 14.9086 0.180492C13.8635 1.1361 12.9028 2.14467 11.942 3.18867C10.9981 4.23279 10.071 5.29444 9.17763 6.39152C7.86288 8.03713 6.5987 9.75364 5.4188 11.5232L1.13744 6.69234C0.935203 6.46227 0.598112 6.39154 0.32839 6.56842C0.0081006 6.76307 -0.0930037 7.18782 0.0924155 7.5239C0.0924155 7.5239 4.17151 14.9029 4.34006 15.2214C4.50867 15.5222 4.87951 16 5.63799 16C6.37967 16 6.78412 15.54 7.02022 15.0621C7.27301 14.5667 9.53176 10.1782 10.9982 7.86014C11.7229 6.69222 12.5151 5.55972 13.3074 4.44494C14.1164 3.33011 14.9592 2.23303 15.8189 1.2067L15.8357 1.18905C16.0548 0.888242 16.0548 0.498929 15.8356 0.233436L15.8356 0.233569Z",
    fill: "#3582D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCheckIcon);
export default __webpack_public_path__ + "static/media/blue-check-icon.dcc75bd1eae3f826b0b017a87429fe38.svg";
export { ForwardRef as ReactComponent };